module.exports = __webpack_public_path__ + "img/Nilsen_Gamle_Vika.44da3d49.jpg";